// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__3XUCh","wrapper":"Modal_wrapper__kkMdf","close":"Modal_close__2NWPR","header":"Modal_header__1LsXt","body":"Modal_body__16uus"};